module.exports = __webpack_public_path__ + "assets/img/A-3947b6a5.jpg";